import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="search--fill-form"
export default class extends Controller {
  static targets = ['form'];

  connect() {
    var raw_search_items = this.formTarget.dataset.prefill;
    if (raw_search_items) {
      var search_items = JSON.parse(raw_search_items);
      this.fill_form(this.formTarget, search_items);
    }
  }

  clear(ev) {
    ev.preventDefault();
    this.clear_form(this.formTarget);
  }

  clear_form(form) {
    const ignored_field_names = [
      'authenticity_token',
      'utf8',
      'search[sort_order]',
      'search[direction]',
      'search[search_type]',
    ];
    const ignored_field_types = [
      'submit', 'reset', 'button'
    ];

    for (let el of form.elements) {
      if (ignored_field_names.indexOf(el.name) < 0) {
        if (ignored_field_types.indexOf(el.type) < 0) {
          if (el.type == 'select-one' || el.type == 'select-multiple') {
            // Uncheck all checked options
            el.querySelectorAll('option:checked').forEach(option => {
              option.selected = false;
            });
          } else if (el.type == 'checkbox' || el.type == 'radio') {
            el.checked = false;
          } else {
            // presumably some sort of text input
            el.value = '';
          }
        }
      }
    }

    // Notify multiselect controllers to refresh their UI
    this.refreshMultiselectControllers(form);

    // Clear tag-search controllers
    this.clearTagSearchControllers(form);
  }

  refreshMultiselectControllers(form) {
    // Find all select elements with multiselect controller
    const multiselectElements = form.querySelectorAll('[data-controller*="multiselect"]');
    multiselectElements.forEach(element => {
      const controller = this.application.getControllerForElementAndIdentifier(element, 'multiselect');
      if (controller && typeof controller.refresh === 'function') {
        controller.refresh();
      }
    });
  }

  clearTagSearchControllers(form) {
    // Find all elements with tag-search controller
    const tagSearchElements = form.querySelectorAll('[data-controller*="tag-search"]');
    tagSearchElements.forEach(element => {
      const controller = this.application.getControllerForElementAndIdentifier(element, 'tag-search');
      if (controller && typeof controller.clearTags === 'function') {
        controller.clearTags();
      }
    });
  }

  fill_form(form, search_items) {
    this.set_simple_values(form, 'texts', search_items);
    this.set_complex_values(form, 'cond', search_items);
    this.set_complex_values(form, 'with_all', search_items);
    this.set_search_stuff(form, search_items);
  }

  set_simple_values(form, type, search_items) {
    if (search_items[type]) {
      for (let search_item in search_items[type]) {
        let val = search_items[type][search_item];
        if (val) {
          let el = form.querySelector('#search_search_params_' + type + '_' + search_item);
          if (el) { el.value = val; }
        }
      }
    }
  }

  set_complex_values(form, type, search_items) {
    if (search_items[type]) {
      for (let search_item in search_items[type]) {
        const val = search_items[type][search_item];
        this.set_complex_value_single(form, type, search_item, val) ||
          this.set_complex_value_multiple(form, type, search_item, val);
      }
    }
  }

  set_complex_value_single(form, type, search_item, val) {
    const els = form.querySelectorAll('[name="search[search_params][' + type + '][' + search_item + ']"]');
    if (els.length > 0) {
      const el = els[0];
      if (Array.isArray(val)) {
        val.forEach(v => {
          this.apply_selected(el, v);
        });
      } else {
        this.apply_selected(el, val);
      }
      return true;
    } else {
      return false;
    }
  }

  set_complex_value_multiple(form, type, search_item, val) {
    const els = form.querySelectorAll('[name="search[search_params][' + type + '][' + search_item + '][]"]');
    if (els.length > 0) {
      Array.from(els).forEach(el => {
        if (Array.isArray(val)) {
          val.forEach(v => {
            this.apply_selected(el, v);
          });
        } else {
          this.apply_selected(el, val);
        }
      });
    } else {
      return false;
    }
  }

  // field types: select-one, select-multiple, checkbox, and radio
  // We won't see: submit, reset, button
  // For select-one and select-multiple, we set the "selected" value
  // of the option that matches the value we're setting.
  // For checkbox, we set the "checked" value of the input
  // For radio, we set the "checked" value where the value matches
  // the value we're setting.
  apply_selected(el, val) {
    switch (el.type) {
      case 'select-one':
      case 'select-multiple':
        let option_el = el.querySelector('option[value="' + val + '"]');
        if (option_el) { option_el.selected = true; }
        break;
      case 'checkbox':
        el.checked = !!val;
        break;
      case 'radio':
        if (el.value == val) { el.checked = true; }
        break;
      default:
        // presumably, text, number, date, etc.
        el.value = val;
    }
  }

  set_search_stuff(form, search_items) {
    this.set_search_stuff_simple(form, search_items, 'sort_order');
    this.set_search_stuff_simple(form, search_items, 'direction');
  }

  set_search_stuff_simple(form, search_items, name) {
    if (search_items[name]) {
      let el = form.querySelector('#search_' + name);
      if (el) { el.value = search_items[name]; }
    }
  }
}
